module.exports = __webpack_public_path__ + "sunsemweb/img/hbanner2.1d93f3ce.png";